import { formatDistanceToNow } from "date-fns";

/**
 * Format a date as a short relative string (e.g., "2mo ago", "3d ago", "1h ago")
 */
export function formatShortDistance(date: Date): string {
  const distance = formatDistanceToNow(date, { addSuffix: true });

  // Convert verbose format to short format
  if (distance === "less than a minute ago") {
    return "just now";
  }

  return distance
    .replace(/about\s+/, "")
    .replace(/\s+months?\s+ago/, "mo ago")
    .replace(/\s+days?\s+ago/, "d ago")
    .replace(/\s+hours?\s+ago/, "h ago")
    .replace(/\s+minutes?\s+ago/, "m ago")
    .replace(/\s+seconds?\s+ago/, "s ago")
    .replace(/\s+years?\s+ago/, "y ago")
    .replace(/\s+weeks?\s+ago/, "w ago");
}
